import React, { useEffect, useState } from "react";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  CardTitle,
} from "reactstrap";
import InputMask from "react-input-mask";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import classnames from "classnames";
import { Link, useNavigate } from "react-router-dom";
import Spinners from "components/Common/Spinner";
import Select from "react-select";
import Config from "config";
const FormWizard = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  //meta title
  document.title = "DOM COM | Nouvel investisseur";
  const token = localStorage.getItem("auth_token");
  const tableaustyles = {
    background: "#3c88c8",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  // Nom, prénom, date de naissance, ville de naissance, département de naissance, profession
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [dateNaissance, setDateNaissance] = useState("");
  const [villeNaissance, setVilleNaissance] = useState("");
  const [depNaissance, setDepNaissance] = useState("");
  const [profession, setProfession] = useState("");
  const [adresseFiscale, setAdresseFiscale] = useState("");
  const [complementAdresse, setComplementAdresse] = useState("");
  const [codePostal, setCodePostal] = useState("");
  const [ville, setVille] = useState("");
  const [emailPersonnel, setEmailPersonnel] = useState("");
  const [emailProfessionel, setEmailProfessionel] = useState("");
  const [telephoneFixe, setTelephoneFixe] = useState("");
  const [telephoneMobile, setTelephoneMobile] = useState("");

  /*************************   TITRE *******************************/
  const [titreData, setTitreData] = useState({ data: [] });
  const [titre, setTitre] = useState("");
  const renderTitreOptions = () => {
    return [
      {
        options: titreData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const handleTitreChange = (e) => {
    setTitre(e);
  };
  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Titre *******************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getTitre();
        await getSituationMatrimoniale();
        await getPay();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);
  /*************************   Pays  *******************************/
  const [pay, setPay] = useState("");
  const [payData, setPayData] = useState({ data: [] });
  const renderPayOptions = () => {
    return [
      {
        options: payData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handlePayChange = (e) => {
    setPay(e);
  };
  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Pays *******************************/

  /*************************   SituationMatrimoniale  *******************************/
  const [situationMatrimonialeData, setSituationMatrimonialeData] = useState({
    data: [],
  });

  const [situationMatrimoniale, setSituationMatrimoniale] = useState("");

  const renderSituationMatrimonialeOptions = () => {
    return [
      {
        options: situationMatrimonialeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSituationMatrimonialeChange = (e) => {
    setSituationMatrimoniale(e);
  };
  const getSituationMatrimoniale = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/situation_matrimoniales`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((situationMatrimoniale) => {
          setSituationMatrimonialeData(situationMatrimoniale);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END SituationMatrimoniale *******************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/investisseurs/send_new_invest`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            nom: nom,
            prenom: prenom,
            titre_id: titre?.value || "",
            date_de_naissance: dateNaissance,
            ville_de_naissance: villeNaissance,
            departement_ou_pays: depNaissance,
            profession: profession,
            situation_matrimoniale_id: situationMatrimoniale?.value || "",
            pay_id: pay?.value || "",
            adresse_fiscale: adresseFiscale,
            complement_adresse: complementAdresse,
            code_postal: codePostal,
            ville: ville,
            email_perso: emailPersonnel,
            email_professionel: emailProfessionel,
            tel_fixe: telephoneFixe,
            tel_mob: telephoneMobile,
          }),
        }
      );
      if (response.ok) {
        console.log("POST request successful");
        const responseData = await response.json();
        toast.success(responseData?.message);
        navigate(`${backUrl}/investisseurs/${responseData?.investisseur_id}`);
        setLoading(false);
      } else {
        console.error("POST request failed");
        const responseData = await response.json();
        if (responseData && responseData.error) {
          toast.error(responseData.error);
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-4 card-title flex-grow-1"
                      style={{ fontWeight: "bold" }}
                    >
                      <Link
                        to={`${backUrl}/investisseurs/`}
                        style={{
                          color: "#3c88c8",
                          textDecoration: "underline !important",
                        }}
                      >
                        Investisseurs
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i> Nouvel investisseur
                    </h5>
                  </div>
                  {loading ? (
                    <Spinners setLoading={setLoading} setWait={400} />
                  ) : (
                    <>
                      <div className="wizard clearfix">
                        <div className=" clearfix">
                          <Card>
                            <TabPane tabId={1}>
                              <Form>
                                <>
                                  <Row>
                                    <Col sm="6">
                                      <Card className="mb-4">
                                        <CardTitle
                                          tag="h5"
                                          style={{
                                            paddingLeft: "10px",
                                            paddingTop: "10px",
                                          }}
                                        >
                                          {" "}
                                          Coordonnées personnelles
                                        </CardTitle>
                                        <CardBody>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Titre :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <Select
                                                value={titre}
                                                onChange={handleTitreChange}
                                                options={renderTitreOptions()}
                                                isClearable={true}
                                                className="select2"
                                                isSearchable={false}
                                                placeholder="Titre"
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Nom :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                defaultValue={nom}
                                                required
                                                onChange={(e) =>
                                                  setNom(e.target.value)
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Prénom :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                defaultValue={prenom}
                                                required
                                                onChange={(e) =>
                                                  setPrenom(e.target.value)
                                                }
                                              />
                                            </Col>
                                          </Row>

                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Date de naissance :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <InputMask
                                                mask="99/99/9999"
                                                value={dateNaissance}
                                                className="form-control input-color"
                                                onChange={(dateString) => {
                                                  setDateNaissance(
                                                    dateString.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Ville de naissance :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                defaultValue={villeNaissance}
                                                required
                                                onChange={(e) =>
                                                  setVilleNaissance(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Département de naissance :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                defaultValue={depNaissance}
                                                required
                                                onChange={(e) =>
                                                  setDepNaissance(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                    <Col sm="6">
                                      <Card className="mb-4">
                                        <CardTitle
                                          tag="h5"
                                          style={{
                                            paddingLeft: "10px",
                                            paddingTop: "10px",
                                          }}
                                        >
                                          Adresse
                                        </CardTitle>
                                        <CardBody>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Adresse résidence fiscale :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                required
                                                onChange={(e) =>
                                                  setAdresseFiscale(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Complément adresse :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                required
                                                onChange={(e) =>
                                                  setComplementAdresse(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Code postal :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                required
                                                onChange={(e) =>
                                                  setCodePostal(e.target.value)
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Ville :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                required
                                                onChange={(e) =>
                                                  setVille(e.target.value)
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Pays :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <Select
                                                onChange={handlePayChange}
                                                options={renderPayOptions()}
                                                isClearable={true}
                                                className="select2"
                                              />
                                            </Col>
                                          </Row>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col sm="6">
                                      <Card className="mb-4">
                                        <CardTitle
                                          tag="h5"
                                          style={{
                                            paddingLeft: "10px",
                                            paddingTop: "10px",
                                          }}
                                        >
                                          Coordonnées de contact
                                        </CardTitle>
                                        <CardBody>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  E-mail personnel :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                required
                                                onChange={(e) =>
                                                  setEmailPersonnel(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  E-mail professionnel :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                required
                                                onChange={(e) =>
                                                  setEmailProfessionel(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Téléphone fixe :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                required
                                                onChange={(e) =>
                                                  setTelephoneFixe(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Téléphone mobile :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                required
                                                onChange={(e) =>
                                                  setTelephoneMobile(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </Col>
                                          </Row>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                    <Col sm="6">
                                      <Card className="mb-4">
                                        <CardTitle
                                          tag="h5"
                                          style={{
                                            paddingLeft: "10px",
                                            paddingTop: "10px",
                                          }}
                                        >
                                          Renseignements Divers
                                        </CardTitle>
                                        <CardBody>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Profession :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <input
                                                className="form-control"
                                                defaultValue={profession}
                                                required
                                                onChange={(e) =>
                                                  setProfession(e.target.value)
                                                }
                                              />
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={4}
                                              className="col-md-4 mb-2"
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span
                                                  style={{
                                                    display: "inline-block",
                                                    width: "11em",
                                                    paddingTop: "10px",
                                                  }}
                                                >
                                                  Situation matrimoniale :
                                                </span>
                                              </i>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={4}
                                              lg={8}
                                              className="mb-2 col-md-8"
                                            >
                                              <Select
                                                value={situationMatrimoniale}
                                                onChange={
                                                  handleSituationMatrimonialeChange
                                                }
                                                options={renderSituationMatrimonialeOptions()}
                                                isClearable={true}
                                                className="select2"
                                                isSearchable={false}
                                              />
                                            </Col>
                                          </Row>
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                </>
                              </Form>
                            </TabPane>
                          </Card>
                        </div>
                        <div className="actions clearfix">
                          <ul>
                            <li>
                              <button
                                className="btn btn-info"
                                onClick={handleSubmit} // validation PP
                              >
                                Créer
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default FormWizard;
